package core.dateformat.ui

import androidx.compose.runtime.Composable
import core.dateformat.domain.DateFormatUseCase
import org.koin.compose.koinInject

@Composable
fun String.formatDate(
    separator: String = "/",
    excludeYear: Boolean = false,
): String {
    val dateFormatUseCase = koinInject<DateFormatUseCase>()
    return dateFormatUseCase.formatDate(this, separator, excludeYear)
}

@Composable
fun List<String?>.formatIsoDateRange()
    : ArrayList<HashMap<String, String>> {
    if (this.isEmpty() || this.size < 2) return arrayListOf()

    val dateFormatUseCase = koinInject<DateFormatUseCase>()
    return dateFormatUseCase.formatIsoDateRange(this[0], this[1])
}

@Composable
fun List<String?>.formatDateRange(): String {
    if (this.isEmpty() || this.size < 2) return ""

    val dateFormatUseCase = koinInject<DateFormatUseCase>()
    return dateFormatUseCase.formatDateRange(this[0], this[1])
}

@Composable
fun String.formatDateToPrettyString(): String? {
    val dateFormatUseCase = koinInject<DateFormatUseCase>()
    return dateFormatUseCase.formatDateToPrettyString(this)
}